var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00002 0.333344C6.46026 0.333344 6.83335 0.706439 6.83335 1.16668V10.8215L10.4108 7.24409C10.7362 6.91865 11.2638 6.91865 11.5893 7.24409C11.9147 7.56952 11.9147 8.09716 11.5893 8.4226L6.58928 13.4226C6.26384 13.748 5.7362 13.748 5.41076 13.4226L0.410765 8.4226C0.0853278 8.09716 0.0853278 7.56952 0.410765 7.24409C0.736202 6.91865 1.26384 6.91865 1.58928 7.24409L5.16669 10.8215V1.16668C5.16669 0.706439 5.53978 0.333344 6.00002 0.333344Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDown);
export default __webpack_public_path__ + "static/media/ico-arrow_down.8f23baef95e1509bd023cf56ddef8531.svg";
export { ForwardRef as ReactComponent };